import { keyBy } from 'es-toolkit';

export const makeCache = <K extends keyof any, V>(generator: (key: K) => V) => {
  const cache: { [K0 in K]?: V } = {};
  return (key: K) => (Object.prototype.hasOwnProperty.call(cache, key) ? cache[key]! : (cache[key] = generator(key)));
};

/** Returns a wrapped version of `generator` that caches results for identical inputs. */
export const makeWeakCache = <K extends object, V>(generator: (key: K) => V) => {
  const cache = new WeakMap<K, V>();
  return (key: K): V => {
    if (!cache.has(key)) {
      cache.set(key, generator(key));
    }
    return cache.get(key)!;
  };
};

/** Returns a cached version of `keyBy` for a pre-specified key extractor function. */
export const makeKeyByCache = <T, K extends string>(keyExtractor: (item: T) => string) =>
  makeWeakCache((array: readonly T[]) => keyBy(array, keyExtractor) as { readonly [K0 in K]?: T });
